define.alias("shared/utils/string-formatters/remove-underscores", "media/utils/string-formatters/remove-underscores");